export default {
  'sequences.title': 'Gestionar Secuencias',
  'sequence.pattern': 'Patrón',
  'sequence.subSequences': 'Subsecuencias',
  'sequence.sequenceTraces': 'Trazas',
  'sequence.automaticNumbersCurrentYear': 'Año Actual - Numeración Automática',
  'sequence.automaticNumbersCurrentMonth': 'Mes Actual - Numeración Automática',
  'sequence.automaticNumbersCurrentDay': 'Día Actual - Numeración Automática',
  'sequence.lastGeneratedNumber': 'Último Número Generado',
  'sequence.rowVersion': 'Versión de Registro',
  'sequence.sequenceItem': 'Subsecuencia',
  'sequence.generatedNumber': 'Número Generado',
  'sequence.referenceItemId': 'ID Referencia',
  'sequence.referenceItemDescription': 'Descripción Referencia',
  'sequence.referenceEntity': 'Entidad Referencia',
};
